import Navbar from '@/components/layout/Navbar'
import Footer from '@/components/layout/Footer'

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen flex flex-col bg-accent font-sans text-white selection:bg-white selection:text-accent">
      <Navbar />
      <main className="relative flex-1 pt-36 pb-28 md:pt-40 md:pb-32">
        <div className="absolute inset-0 bg-gradient-to-b from-accent/80 via-transparent to-accent pointer-events-none" />
        <div className="container relative z-10 max-w-2xl mx-auto px-8">
          <h1 className="text-4xl md:text-5xl font-bold font-heading text-white uppercase tracking-tight mb-12">
            Privacy Policy
          </h1>

          <div className="space-y-8 text-slate-200 leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-white mb-4">1. Introduction</h2>
              <p>
                This template includes a placeholder Privacy Policy. Replace this content with your own policy before launching your project.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">2. Information We Collect</h2>
              <p>Update this section to describe what your application collects.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">3. How We Use Your Information</h2>
              <p>Update this section to describe how you use collected data.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">4. Contact</h2>
              <p>
                For questions about this Privacy Policy, contact us at{' '}
                <a href="mailto:hello@example.com" className="text-white underline hover:no-underline">
                  hello@example.com
                </a>
                .
              </p>
            </section>
          </div>

          <hr className="border-white/20 mt-12 mb-6" />
          <p className="text-white text-xs">Last updated: {new Date().toLocaleDateString()}</p>
        </div>
      </main>
      <Footer />
    </div>
  )
}
